import {Action, action, State} from "easy-peasy";
import "styled-components/macro";

export function setFactory<ModelT extends {}, PayloadT>(name: string): Action<State<ModelT>, PayloadT> {
  return action((state, payload) => {
    state[name] = payload;
  });
}
export const pushFactory = (name) =>
  action((state, payload) => {
    state[name].push(payload);
  });
export const onChangeFactory = (handleValueChange) => (ev) => {
  ev.preventDefault();
  handleValueChange(ev.target.value);
};
export const nfFloat = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
